/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Rules_Seo_Tournament_Version_DescriptionInputs */



/**
* | output |
* | --- |
* | "Riftbound tournament rules, version {version}." |
*
* @param {Rules_Seo_Tournament_Version_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const rules_seo_tournament_version_description = /** @type {((inputs: Rules_Seo_Tournament_Version_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rules_Seo_Tournament_Version_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Riftbound-Turnierregeln, Version ${i?.version}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Règles de tournoi de Riftbound, version ${i?.version}.`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`Riftbound 赛事规则，版本 ${i?.version}。`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`Riftbound 賽事規則，版本 ${i?.version}。`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`Riftbound 대회 규정, 버전 ${i?.version}.`)
	return /** @type {LocalizedString} */ (`Riftbound tournament rules, version ${i?.version}.`)
});